import { render } from "./c-address-full.vue?vue&type=template&id=08973464"
import script from "./c-address-full.vue?vue&type=script&lang=js"
export * from "./c-address-full.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__